import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  forwardRef,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { FormGroup } from '@angular/forms';
import {
  CountryISO,
  SearchCountryField,
  PhoneNumberFormat,
} from 'ngx-intl-tel-input';

@Component({
  standalone: false,
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrl: './phone-input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneInputComponent),
      multi: true,
    },
  ],
})
export class PhoneInputComponent
  implements OnInit, OnChanges, ControlValueAccessor
{
  @Input() formGroup: FormGroup;
  @Input() formControlName = '';
  @Input() label = '';
  @Input() widthLimited = false;
  @Input() darkBackground = false;
  isRequired = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
    CountryISO.Germany,
    CountryISO.France,
    CountryISO.Albania,
    CountryISO.Kosovo,
  ];
  @Input() selectedCountryISO: CountryISO = this.preferredCountries[0];
  value: string;

  onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};

  ngOnInit() {
    this.updateRequiredValidator();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formGroup'] || changes['formControlName']) {
      this.updateRequiredValidator();
    }
  }

  private updateRequiredValidator() {
    this.isRequired = this.hasRequiredValidator(this.formControlName);
  }

  private hasRequiredValidator(controlName: string): boolean {
    const control: AbstractControl = this.formGroup.get(controlName);
    if (control && control.validator) {
      const validators = control.validator({} as AbstractControl);
      return validators && validators['required'] !== undefined;
    }
    return false;
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value); // Notify the form about the change
    this.onTouched(); // Mark as touched
  }
}
